import React, { useEffect, useState } from 'react';
import "./Sidebar.css";
import { Avatar, IconButton } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { SearchOutlined } from "@material-ui/icons";
import SidebarChat from "./SidebarChat";
import db from "./firebase";
import { useStateValue } from './StateProvider';
import ScrollArea from "react-scrollbar";

function Sidebar() {

    const [rooms, setRooms] = useState([]);
    const [{ user }, dispatch] = useStateValue();

    useEffect(() => {

        const unsubscribe = db.collection('rooms').onSnapshot(snapshot => (
            setRooms(snapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data(),
            })
            ))
        ))
        // snapshot - everytime changes

        return () => {
            unsubscribe();
            // to make it optimal and save cache
        }

    }, [])
    // run this once when sidebar component loads

    return (
        <div className="sidebar">
            {/* <h1>I am a sidebar.</h1> */}

            <div className="sidebar__header">

                <Avatar src={user?.photoURL} />
                {/* <h4><small>{user.displayName}</small></h4> */}

                <div className="sidebar__headerRight">

                    <IconButton>
                        <DonutLargeIcon />
                    </IconButton>

                    <IconButton>
                        <ChatIcon />
                    </IconButton>

                    <IconButton>
                        <MoreVertIcon />
                    </IconButton>
                </div>
            </div>

            <div className="sidebar__search">
                <div className="sidebar__searchContainer">
                    <SearchOutlined />
                    <input placeholder="Search or Start a new chat." type="text" />
                </div>
            </div>

            <ScrollArea speed={0.8}
                className="area"
                contentClassName="content"
                horizontal={true}  >
                <div className="sidebar__chats">
                    <SidebarChat addNewChat />

                    {rooms.map(room => (
                        <SidebarChat key={room.id} id={room.id} name={room.data.name} />
                    ))}
                </div>
            </ScrollArea>


        </div>
    )
}

export default Sidebar
